import React from "react";
import "./CaseStudies.css";

import img1 from "./images/case1.jpg";
import img2 from "./images/case2.jpg";
import img3 from "./images/case3.jpg";
import img4 from "./images/case4.jpg";
import img5 from "./images/case5.jpg";
import img6 from "./images/case6.jpg";

const CaseStudies = () => {

  const images = [img1, img2, img3, img4, img5, img6];

  return (
    <div className="case-studies">

      <div className="container text-center">
        <h2 className="case-title">— Case Studies —</h2>
         <p className="case-sub">
          Explore our gallery to see how we provide effective pest management solutions.
        </p>
      </div>

      <div className="slider">

        <div className="case-track">

          {[...images, ...images].map((img, i) => (
            <div className="slide" key={i}>
              <img src={img} alt="case" />
            </div>
          ))}

        </div>

      </div>

    </div>
  );
};

export default CaseStudies;